import { Container, Section } from '@resolute/ui';

import { ContactForm } from './components/contact-form';
import { ContactInfo } from './components/contact-info';
import { ContactMap } from './components/contact-map';
import { CONTACT_DETAILS } from './contact-details';

import { Reveal } from '@/components/motion/reveal';
import { PageHero } from '@/components/page-hero';
import { clientEnv } from '@/lib/env';
import { Seo } from '@/lib/seo';


const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'RealEstateAgent',
  name: clientEnv.siteName,
  url: `${clientEnv.siteUrl}/contact`,
  email: CONTACT_DETAILS.email,
  telephone: CONTACT_DETAILS.phones[0]?.value,
  address: {
    '@type': 'PostalAddress',
    streetAddress: CONTACT_DETAILS.addressLines[1],
    addressLocality: 'Ahmedabad',
    addressRegion: 'Gujarat',
    addressCountry: 'IN',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: CONTACT_DETAILS.map.lat,
    longitude: CONTACT_DETAILS.map.lng,
  },
  sameAs: CONTACT_DETAILS.social.map((s) => s.href),
};

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Contact Us"
        description="Get in touch with Resolute Property Solutions. Talk to an advisor about residential, commercial, pre-leased and GIFT City opportunities across India's growth corridors."
        path="/contact"
        jsonLd={jsonLd}
      />

      <PageHero
        eyebrow="Contact Us"
        title="Let's talk."
        titleLine2="We're ready when you are."
        description="Whether you're buying, investing or just exploring, our advisors are here to help. Tell us what you're looking for and we'll get back to you within one business day."
      />

      {/* Form + info */}
      <Section>
        <Container>
          <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr] lg:gap-14">
            <Reveal>
              <div className="rounded-xl border border-border bg-card p-6 shadow-lg sm:p-7">
                <h2 className="font-display text-2xl font-semibold tracking-tight">
                  Send us a message
                </h2>
                <p className="mt-2 text-sm text-muted-foreground">
                  Fields marked <span className="text-danger">*</span> are required.
                </p>
                <div className="mt-6">
                  <ContactForm />
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="flex flex-col gap-6">
                <ContactInfo />
              </div>
            </Reveal>
          </div>
        </Container>
      </Section>

      {/* Map — last section before the footer, so it uses the `lg` tier
          (matching the closing band on FAQ) for generous breathing room,
          rather than a hardcoded padding override off the shared scale. */}
      <Section spacing="lg">
        <Container>
          <Reveal>
            <ContactMap />
          </Reveal>
        </Container>
      </Section>
    </>
  );
}
